module.exports = __webpack_public_path__ + "img/jianhuo-h.2ea6226b.svg";